import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from 'react-native';
import Button from '@dbk/ui-buttons';
import Spinner from '@dbk/ui-spinner';
import BlurModal from '../../../../components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';
import { ROUTES } from '../../../../../src/constants';


class DocUploadFinalize extends PureComponent {

  constructor(props) {
    super(props)
  }
  changePage = () => {
    this.props.changePage((ROUTES.RMACCESS.DOC_LANDING_PAGE));
  }

  continueClicked = () => {
    const { docupload: { setDocUploadWizardIndex } } = this.props;
    setDocUploadWizardIndex(0);
  }

  closeBlurModel = () => {
    this.props.docupload.setBlurModalError(false);
  }

  componentWillUnmount() {
    const { docupload: { setUploadFormData, setFinalizeSuccess, setDocUploadWizardIndex } } = this.props;
    setUploadFormData(null);
    setFinalizeSuccess(false);
    setDocUploadWizardIndex(0);
  }

  render() {


    const { i18n: { messages }, docupload: { uploadFormData, showErrorModalFinalize, finalizeSuccess, finalize: { showSpinner } } } = this.props;

    return (
      <div className="columns small-12
                           medium-12 large-12
                           document-upload">

        <div className="columns small-12 medium-12 large-8 large-centered doc-upload-finalize-box">

          {!showSpinner && showErrorModalFinalize &&
            <div className="doc-upload-finalize">
              {messages['app.rmAccess.genericError']}
            </div>
          }
          {!showSpinner && finalizeSuccess && <div className="doc-upload-finalize">

            {messages['app.docUpload.finalize.msg_first'] + " " + `${uploadFormData.browseFileName.name}` + " " + messages['app.docUpload.finalize.msg_last']}
          </div>
          }

          {showSpinner && <div className="columns large-2 large-centered padding-bottom-20 padding-top-20">
            <Spinner testID="spinner_uploadFinalize_loading_test"
              accessibilityLabel="spinner_uploadFinalize_loading_test" /></div>
          }

          {!showSpinner && <div className="doc-upload-finalize-finish-btn">
            <Button
              size='large'
              textID="btn_uploadDoc_finishUpload_uploadNew_test"
              accessibilityLabel="btn_uploadDoc_finishUpload_uploadNew_test"
              onPress={() => this.continueClicked()}
            > {messages['app.docUpload.finalizeUploadNewDocument.btn']}
            </Button>
            <Button
              size='large'
              textID="btn_uploadDoc_finishUpload_exit_test"
              accessibilityLabel="btn_uploadDoc_finishUpload_exit_test"
              onPress={() => this.changePage()}
            > {messages['app.docUpload.finalizeExit.btn']}
            </Button>
          </div>}

        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    i18n: {
      messages: true,
    },
    docupload: {
      callFinalizeDocUpload: { $call: 'finalizeDocUpload' },
      selectedContractDetails: true,
      uploadFormData: true,
      finalizeSuccess: true,
      finalize: { showSpinner: true },
      setDocUploadWizardIndex: { $set: 'docUploadWizardIndex' },
      errorMsg: true,
      docMetaDataId: true,
      showErrorModal: true,
      errorTitle: true,
      setBlurModalError: { $set: 'showErrorModal' },
      setFinalizeSuccess: { $set: 'finalizeSuccess' },
      setUploadFormData: { $set: 'uploadFormData' },
    },
  }
})(DocUploadFinalize)


